<template>
    <v-card outlined dense>
        <v-expansion-panels v-model="panel" multiple>
            <!-- ══════════════════════════════════════════════════════════
                 SECTION 1 — DESTINO
            ══════════════════════════════════════════════════════════ -->
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <div class="d-flex align-center">
                        <b>DESTINO</b>
                    </div>
                    <template v-slot:actions>
                        <div class="d-flex align-center" @click.stop>
                            <v-btn @click.stop="printEnvio(7)" dark color="green" small class="mr-1">A4</v-btn>
                            <span class="mx-1">-</span>
                            <v-btn @click.stop="printEnvio(6)" dark color="green" small class="mr-2">TICKET</v-btn>
                            <v-icon>$expand</v-icon>
                        </div>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row dense align="center" class="pa-2">
                        <v-col cols="12" sm="12">
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-autocomplete
                                        dense
                                        outlined
                                        v-model="resolvedUbigeo"
                                        :items="ubigeoItems"
                                        :loading="ubigeoLoading"
                                        :search-input.sync="ubigeoSearch"
                                        :item-text="ubigeoLabel"
                                        item-value="id"
                                        return-object
                                        label="Distrito de envío"
                                        no-data-text="Escribe para buscar..."
                                        clearable
                                        @change="onUbigeoSelect"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field outlined dense v-model="datos.direccion" label="Dirección de envío" placeholder="direccion" />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field outlined dense v-model="datos.referencia" label="Referencia" />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field outlined dense v-model="datos.atributos.nombreProducto" label="Nombre del producto" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field
                                outlined
                                dense
                                v-model="datos.atributos.documentoReceptor"
                                append-icon="mdi-account-search"
                                @click:append="getDatosExternal"
                                label="DNI/RUC (Recibe)"
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field outlined dense v-model="datos.atributos.fullNameReceptor" label="Nombre/Razon Social (Recibe)" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field outlined dense v-model="datos.celularContacto" label="Celular (Recibe)" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-autocomplete
                                outlined
                                dense
                                v-model="datos.formaEntrega"
                                item-text="text"
                                item-value="id"
                                :items="tipoFormaEntrega"
                                label="Forma de Entrega"
                            />
                        </v-col>
                        <template v-if="datos.agenciaEnvio == 13">
                            <v-col cols="12" sm="3">
                                <v-text-field outlined dense v-model="datos.atributos.otherAgenciaEnvio" label="Nombre Agencia" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field outlined dense v-model="datos.atributos.dirAgenciaEnvio" label="Dirección Agencia" />
                            </v-col>
                        </template>
                        <template v-if="[7, 2].includes(datos.formaEntrega)">
                            <v-col cols="12" sm="3">
                                <v-text-field outlined dense v-model="datos.atributos.nombreAgenciaDelivery" label="Nombre Agencia" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field outlined dense v-model="datos.atributos.sedeAgenciaDelivery" label="Sede Agencia" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field outlined dense v-model="datos.atributos.linkAgenciaDelivery" label="Link Agencia" />
                            </v-col>
                        </template>
                        <v-col cols="12" sm="3">
                            <v-text-field outlined dense v-model="datos.googleMaps" label="Enlace de Google Maps" />
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- ══════════════════════════════════════════════════════════
                 SECTION 2 — LOGÍSTICA DE ENTREGA
            ══════════════════════════════════════════════════════════ -->
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <b>LOGÍSTICA DE ENTREGA</b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row dense align="center" class="pa-2">
                        <v-col cols="12" sm="3">
                            <v-autocomplete
                                data-vv-name="datos.atributos.idModotransporte"
                                data-vv-as="idModotransporte"
                                outlined
                                dense
                                v-model="datos.atributos.idModotransporte"
                                item-text="description"
                                item-value="id"
                                :items="modoTransporte"
                                label="Modo de Transporte"
                            />
                            <div style="font-size: 11px; color: #666; margin-top: -12px; margin-bottom: 4px; line-height: 1.3">
                                <span v-if="datos.atributos.idModotransporte == 1">
                                    📦 <strong>Público:</strong> contratas una empresa transportista registrada (agencia, courier)
                                </span>
                                <span v-else-if="datos.atributos.idModotransporte == 2">
                                    🚚 <strong>Privado:</strong> envías tú mismo, con chofer propio, taxista o flete — ingresar DNI conductor y placa
                                </span>
                                <span v-else style="color: #e65100">Selecciona el modo de transporte según SUNAT Cat. 18</span>
                            </div>
                        </v-col>
                        <v-col v-if="datos.atributos.idModotransporte == 1" cols="12" sm="3">
                            <v-autocomplete
                                outlined
                                dense
                                v-model="datos.agenciaEnvio"
                                item-text="name"
                                item-value="id"
                                :items="listDispatchersValidos"
                                label="Agencia de envío"
                            />
                        </v-col>
                        <v-col v-if="datos.atributos.idModotransporte == 2" cols="12" sm="3">
                            <v-autocomplete
                                outlined
                                dense
                                v-model="datos.atributos.idChofer"
                                :items="listDrivers"
                                label="Chofer"
                                item-text="name"
                                item-value="id"
                            ></v-autocomplete>
                        </v-col>
                        <v-col v-if="datos.atributos.idModotransporte == 2" cols="12" sm="3">
                            <v-autocomplete
                                dense
                                v-model="datos.atributos.placaVehiculo"
                                :items="listTransport"
                                placeholder="Placas"
                                label="Placa de vehiculo"
                                item-text="plate_number"
                                item-value="id"
                                outlined
                            />
                        </v-col>
                        <v-col v-if="datos.atributos.idModotransporte == 1" cols="12" sm="3">
                            <v-text-field outlined dense v-model="datos.atributos.linkFotoProducto" label="Clave de Envio" />
                        </v-col>
                        <v-col v-if="datos.atributos.idModotransporte == 1" cols="12" sm="3">
                            <v-text-field outlined dense v-model="datos.atributos.guiaAgencia" label="Guia de Agencia" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-autocomplete
                                outlined
                                dense
                                v-model="datos.tipoEntrega"
                                item-text="text"
                                item-value="id"
                                :items="tipoSelectEntrega"
                                label="Tipo de entrega"
                            />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field outlined dense type="number" v-model="datos.atributos.pesoProducto" label="Peso del Producto en Kg" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field outlined dense type="number" v-model="datos.atributos.bultos" label="Bultos" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        dense
                                        outlined
                                        v-model="datos.atributos.fechaEnvio"
                                        label="Fecha de Envio"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker v-model="datos.atributos.fechaEnvio" no-title locale="es" :min="today" @input="menu1 = false" />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-autocomplete outlined dense v-model="datos.atributos.supervisor" :items="personal" label="Supervisor"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field outlined dense v-model="datos.destinoFinal" label="Destino Final" />
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- ══════════════════════════════════════════════════════════
                 SECTION 3 — PAGO DEL DELIVERY
            ══════════════════════════════════════════════════════════ -->
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <b>PAGO DEL DELIVERY</b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row dense align="center" class="pa-2">
                        <v-col cols="12" sm="3">
                            <v-text-field dense outlined v-model="datos.montoDelivery" label="Monto" />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-autocomplete
                                outlined
                                dense
                                v-model="datos.atributos.metodoPago"
                                item-text="descripcion"
                                item-value="id"
                                :items="metodoPago"
                                label="Metodo de Pago"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-menu v-model="menu5" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        dense
                                        outlined
                                        v-model="datos.atributos.fechaPago"
                                        label="Fecha de Pago"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker v-model="datos.atributos.fechaPago" no-title locale="es" @input="menu5 = false" />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="3" v-if="datos.atributos.metodoPago != 1">
                            <v-autocomplete
                                outlined
                                dense
                                v-model="datos.formaPago"
                                item-text="description"
                                item-value="id"
                                :items="listTipoBancoDestino"
                                label="Destino Banco"
                            />
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-autocomplete
                                outlined
                                dense
                                v-model="datos.estadoDeuda"
                                item-text="text"
                                item-value="value"
                                :items="tipoEstadoDeuda"
                                label="Estado Deuda"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-col cols="12" sm="3">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            v-bind="attrs"
                                            v-on="on"
                                            color="secondaryTheme"
                                            :disabled="
                                                datos.atributos.envioPagoRealizado ||
                                                !datos.montoDelivery ||
                                                !datos.atributos.metodoPago ||
                                                !datos.atributos.fechaPago
                                            "
                                            @click="sendModule"
                                            >Enviar a Modulo Pagos</v-btn
                                        >
                                    </template>
                                    <span>Registra el pago del delivery/flete en el módulo de pagos (una vez pagado)</span>
                                </v-tooltip>
                            </v-col>
                            <p v-if="datos.atributos.envioPagoRealizado">Ya se envio el pago realizado al modulo de pagos</p>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- ══════════════════════════════════════════════════════════
                 SECTION 4 — PROCESO INTERNO
            ══════════════════════════════════════════════════════════ -->
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <b>PROCESO INTERNO</b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-row>
                                <v-col cols="12">
                                    <h5>Datos de Fabricación</h5>
                                </v-col>
                                <v-col cols="6">
                                    <v-menu
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                dense
                                                outlined
                                                v-model="datos.atributos.fechaFabricacion"
                                                label="Fecha Fabricacion"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                clearable
                                                v-on="on"
                                            />
                                        </template>
                                        <v-date-picker v-model="datos.atributos.fechaFabricacion" no-title locale="es" @input="menu2 = false" />
                                    </v-menu>
                                </v-col>
                                <v-col cols="6">
                                    <v-autocomplete
                                        outlined
                                        dense
                                        v-model="datos.atributos.encargadoFabricacion"
                                        :items="personal"
                                        label="Encargado Fabricación"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-row>
                                <v-col cols="12">
                                    <h5>Datos de Equipamiento</h5>
                                </v-col>
                                <v-col cols="6">
                                    <v-menu
                                        v-model="menu3"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                dense
                                                outlined
                                                v-model="datos.atributos.fechaEquipamiento"
                                                label="Fecha Equipamiento"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                clearable
                                                v-on="on"
                                            />
                                        </template>
                                        <v-date-picker v-model="datos.atributos.fechaEquipamiento" no-title locale="es" @input="menu3 = false" />
                                    </v-menu>
                                </v-col>
                                <v-col cols="6">
                                    <v-autocomplete
                                        outlined
                                        dense
                                        :items="personal"
                                        v-model="datos.atributos.encargadoEquipamiento"
                                        label="Encargado Equipamiento"
                                    >
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <h5>Datos de Embalaje</h5>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-menu v-model="menu4" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        dense
                                        outlined
                                        v-model="datos.atributos.fechaEmbalaje"
                                        label="Fecha Embalaje"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        clearable
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker v-model="datos.atributos.fechaEmbalaje" no-title locale="es" @input="menu4 = false" />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-autocomplete
                                outlined
                                dense
                                :items="personal"
                                v-model="datos.atributos.encargadoEmbalaje"
                                label="Encargado Embalaje"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>

        </v-expansion-panels>

        <!-- NOTIFICACIONES — siempre visible -->
        <v-divider />
        <v-card-title class="pb-1"><b>NOTIFICACIONES</b></v-card-title>
        <v-card-text>
            <v-row dense align="center" class="pa-2">
                <v-col cols="12" sm="12" v-if="datos.celularContacto">
                    <v-col>
                        <v-btn
                            :disabled="datos.atributos?.confirmacionDatoEnvio"
                            :dark="!datos.atributos?.confirmacionDatoEnvio"
                            class="green"
                            target="_blank"
                            elevation="2"
                            @click="sendSmsWhatsapp"
                            >CONFIRMACION DE DATOS DE ENVIO POR WSP</v-btn
                        >
                    </v-col>
                    <v-col>
                        <v-btn
                            :disabled="datos.atributos?.mensajeProgramaEnvio"
                            @click="ProgramWhatsapp"
                            :class="{ 'mr-3': true, green: true }"
                            :dark="!datos.atributos?.mensajeProgramaEnvio"
                            >Programado</v-btn
                        >
                        <v-btn
                            :disabled="datos.atributos?.mensajeEnCamino"
                            @click="routeWhatsapp"
                            :class="{ 'mr-3': true, green: true }"
                            :dark="!datos.atributos?.mensajeEnCamino"
                            >En camino</v-btn
                        >
                        <v-btn
                            :disabled="datos.atributos?.mensajeEntregado"
                            @click="deliveredWhatsapp"
                            :class="{ 'mr-3': true, green: true }"
                            :dark="!datos.atributos?.mensajeEntregado"
                            >Entregado</v-btn
                        >
                        <v-btn
                            :disabled="datos.atributos?.mensajeAgencia"
                            @click="agendarWhatsapp"
                            :class="{ 'mr-3': true, green: true }"
                            :dark="!datos.atributos?.mensajeAgencia"
                            >Agencia</v-btn
                        >
                        <v-btn
                            :disabled="datos.atributos?.mensajeAplicativo"
                            @click="aplicativoWhatsapp"
                            :class="{ 'mr-3': true, green: true }"
                            :dark="!datos.atributos?.mensajeAplicativo"
                            >Aplicativo</v-btn
                        >
                        <v-btn
                            :disabled="datos.atributos?.mensajeRecojo"
                            @click="recojoWhatsapp"
                            :class="{ 'mr-3': true, green: true }"
                            :dark="!datos.atributos?.mensajeRecojo"
                            >Recojo</v-btn
                        ></v-col
                    >
                </v-col>
                <v-col cols="12" sm="12" v-else>
                    <h4 style="color: red">No hay un numero registrado</h4>
                </v-col>
            </v-row>
        </v-card-text>

        <!-- ACCIONES — siempre visible -->
        <v-divider />
        <v-card-text class="pt-3">
            <v-row>
                <v-col cols="12" v-if="disabledGuideRemission && camposFaltantes.length">
                    <span class="font-weight-medium text-caption warning--text">⚠️ Faltan: </span>
                    <v-chip v-for="(campo, index) in camposFaltantes" :key="index" x-small outlined color="warning" class="mr-1 mb-1">
                        {{ campo }}
                    </v-chip>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="d-flex align-start flex-wrap">
                        <v-btn color="primary" :loading="loadingSave" class="mr-3 mb-2" @click="saveDatosEnvio">Guardar datos de envío</v-btn>
                        <v-btn :disabled="disabledGuideRemission" color="primary" :loading="loadGuide" class="mb-2" @click="printRemission"
                            >Imprimir Guía Remisión</v-btn
                        >
                    </div>
                    <v-chip v-if="datos.numeroGuiaRemision" x-small color="success" text-color="white" class="mt-1">
                        <v-icon left x-small>mdi-check</v-icon>
                        Se realizó la emisión
                    </v-chip>
                </v-col>
            </v-row>
        </v-card-text>

    </v-card>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { mixins } from '@/mixins/mixin.js'
import { format } from 'date-fns'
import { sleep } from '@/utils/genericUtils'
import DefaultForm from '@/utils/defaultForm'

export default {
    filters: {},
    mixins: [mixins],
    $_veeValidate: {
        validator: 'new'
    },
    components: {},
    data() {
        return {
            panel: [0],
            loadGuide: false,
            loadingSave: false,
            options: [
                { text: 'PAGADO', value: 2 },
                { text: 'PENDIENTE', value: 1 }
            ],
            metodoPago: [
                { id: 1, descripcion: 'Efectivo' },
                { id: 2, descripcion: 'Tarjeta' },
                { id: 3, descripcion: 'Transferencia' }
            ],
            selected: 1,
            menu1: false,
            menu2: false,
            menu3: false,
            menu4: false,
            menu5: false,
            resolvedUbigeo: null,
            ubigeoSearch: '',
            ubigeoItems: [],
            ubigeoLoading: false,
            searchTimeout: null
        }
    },
    computed: {
        ...mapState('utilities', ['tipoFormaEntrega', 'tipoSelectEntrega', 'tipoEstadoDeuda', 'tipoBancoDestino', 'modoTransporte']),
        ...mapState('ventas', ['datos']),
        ...mapState('proveedor', ['listDispatchers', 'listDrivers', 'listTransport']),
        ...mapState('users', ['personal']),
        ...mapGetters('utilities', ['listTipoBancoDestino']),
        ...mapGetters('users', ['listaChofer']),
        listDispatchersValidos() {
            return this.listDispatchers.filter((x) => x.number !== '00000000000' && x.name?.toUpperCase() !== 'OTROS')
        },
        disabledGuideRemission() {
            return (
                !!this.datos.numeroGuiaRemision ||
                !this.datos.productos ||
                !this.datos.atributos.fechaEnvio ||
                !this.datos.idCliente ||
                !this.datos.referencia ||
                !this.datos.atributos.idModotransporte ||
                !this.datos.atributos.pesoProducto ||
                !this.datos.atributos.bultos ||
                !this.datos.atributos.fullNameReceptor ||
                !this.datos.atributos.documentoReceptor ||
                !this.datos.celularContacto ||
                !this.datos.numeroComprobante
            )
        },
        today() {
            return format(new Date(), 'yyyy-MM-dd')
        },
        camposFaltantes() {
            const faltantes = []

            if (this.datos.numeroGuiaRemision) return []

            if (!this.datos.productos) faltantes.push('Productos')
            if (!this.datos.atributos.fechaEnvio) faltantes.push('Fecha de Envío')
            if (!this.datos.idCliente) faltantes.push('Cliente')
            if (!this.datos.referencia) faltantes.push('Referencia')
            if (!this.datos.atributos.idModotransporte) faltantes.push('Modo de Transporte')
            if (!this.datos.atributos.pesoProducto) faltantes.push('Peso del Producto')
            if (!this.datos.atributos.bultos) faltantes.push('Número de Bultos')
            if (!this.datos.atributos.fullNameReceptor) faltantes.push('Nombre del Receptor')
            if (!this.datos.atributos.documentoReceptor) faltantes.push('Documento del Receptor')
            if (!this.datos.celularContacto) faltantes.push('Celular de Contacto')
            if (!this.datos.numeroComprobante) faltantes.push('Número de Comprobante')
            return faltantes
        }
    },
    methods: {
        ubigeoLabel(item) {
            return `${item.distrito} / ${item.provincia} / ${item.departamento}`
        },
        onUbigeoSelect(item) {
            if (!item) {
                this.$store.commit('ventas/UPDATE_DATOS', { ubigeo: null })
                return
            }
            this.$store.commit('ventas/UPDATE_DATOS', { ubigeo: item.id })
        },
        async saveDatosEnvio() {
            this.loadingSave = true
            try {
                await this.$store.dispatch('ventas/patchVenta', { ...this.datos })
                this.$store.commit('mainUI/OPEN_BAR', { state: true, text: 'Datos de envío guardados', color: 'success' })
            } finally {
                this.loadingSave = false
            }
        },
        async sendModule() {
            await this.$store.dispatch('pagos/enviar_moduloPago', this.datos)
            await this.$store.dispatch('ventas/patchVenta', { ...this.datos, atributos: { ...this.datos.atributos, envioPagoRealizado: true } })
        },
        async printRemission() {
            console.log('[printRemission] INICIO — idVenta:', this.datos.id, 'numeroComprobante:', this.datos.numeroComprobante)
            this.loadGuide = true
            try {
                // Auto-guardar datos de envío antes de generar la guía para evitar pérdida de campos no persistidos
                await this.$store.dispatch('ventas/patchVenta', { ...this.datos })
                console.log('[printRemission] datos.atributos:', JSON.stringify(this.datos.atributos))
                console.log('[printRemission] datos.ubigeo:', this.datos.ubigeo)
                let receptor = `Se realiza la entrega al USUARIO: ${this.datos.atributos.fullNameReceptor}
          con NUMERO DOCUMENTO: ${this.datos.atributos.documentoReceptor} y TELEFONO: ${this.datos.celularContacto}\n`
                // Agregar datos de agencia si existen (con formato HTML para el PDF)
                const agenciaLines = []
                if (this.datos.atributos.nombreAgenciaDelivery) {
                    agenciaLines.push(`<b>📍 AGENCIA:</b> ${this.datos.atributos.nombreAgenciaDelivery}`)
                }
                if (this.datos.atributos.sedeAgenciaDelivery) {
                    agenciaLines.push(`<b>📍 SEDE AGENCIA:</b> ${this.datos.atributos.sedeAgenciaDelivery}`)
                }
                if (this.datos.atributos.otherAgenciaEnvio) {
                    agenciaLines.push(`<b>📍 AGENCIA:</b> ${this.datos.atributos.otherAgenciaEnvio}`)
                }
                if (this.datos.atributos.dirAgenciaEnvio) {
                    agenciaLines.push(`<b>📍 DIR. AGENCIA:</b> ${this.datos.atributos.dirAgenciaEnvio}`)
                }
                if (agenciaLines.length > 0) {
                    receptor += `\n<br>${agenciaLines.join('<br>')}`
                }
                const idLocation = this.datos.ubigeo ? [this.datos.ubigeo.slice(0, 2), this.datos.ubigeo.slice(0, 4), this.datos.ubigeo] : [null, null, null]
                console.log('[printRemission] idLocation:', idLocation)
                const guiaResponse = await this.$store.dispatch('reporte/sendGuiaRemision', {
                    ...this.datos,
                    idLocation,
                    receptor
                })
                console.log('[printRemission] response sendGuiaRemision:', JSON.stringify(guiaResponse))
                const {
                    numeroGuiaRemision: idGuuiaRemision,
                    urlNumeroGuiaRemision: urlGuiaRemision,
                    estadoSunat,
                    mensajeSunat
                } = guiaResponse || {}
                if (!urlGuiaRemision || !idGuuiaRemision) throw new Error('No se pudo generar la guía de remisión')
                this.datos.numeroGuiaRemision = idGuuiaRemision
                this.$store.commit('ventas/UPDATE_DATOS', {
                    numeroGuiaRemision: idGuuiaRemision,
                    atributos: {
                        ...this.datos.atributos,
                        urlGuiaRemision
                    }
                })
                window.open(urlGuiaRemision, '_blank')
                this.$store.commit('ventas/SHOW_MODAL_DATOS_ENVIO', false)
                this.$root.$emit('refresh-reservas')
                if (estadoSunat === 'pendiente') {
                    // La guía se creó y su número ya quedó guardado, pero SUNAT todavía no
                    // confirmó la aceptación: se avisa para que nadie la dé por aceptada
                    // ni la reemita sin revisar el estado en Facturación.
                    this.$store.commit('mainUI/OPEN_MODAL', {
                        state: true,
                        overlay: false,
                        width: '420px',
                        close: true,
                        text: `Guía ${idGuuiaRemision} emitida, pero SUNAT todavía no confirma la aceptación (en proceso). Revisá el estado en Facturación antes de reenviarla.${mensajeSunat ? ` Detalle: ${mensajeSunat}` : ''}`
                    })
                } else {
                    this.$store.commit('mainUI/OPEN_BAR', { state: true, text: 'Guía emitida correctamente', color: 'success' })
                }
            } catch (error) {
                console.error('[printRemission] ERROR:', error)
                console.error('[printRemission] stack:', error.stack)
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    overlay: false,
                    color: 'red',
                    width: '400px',
                    text: error.message || 'Error al generar la guía de remisión',
                    close: true
                })
            } finally {
                this.loadGuide = false
            }
        },
        async getDatosExternal() {
            if (this.datos.atributos.documentoReceptor >= 8) {
                try {
                    console.log('this.datos.atributos.documentoReceptor', this.datos.atributos.documentoReceptor.length)
                    const idTipoDocumento = this.datos.atributos.documentoReceptor.length == 8 ? 1 : 6
                    this.$store.commit('mainUI/OPEN_MODAL', {
                        state: true,
                        text: 'Buscando en Reniec/Sunat',
                        color: 'green'
                    })
                    console.log('this.datps', idTipoDocumento)
                    const resultado = await this.$store.dispatch('clientes/getClienteExternal', {
                        idTipoDocumento: idTipoDocumento,
                        numeroDocumento: this.datos.atributos.documentoReceptor
                    })
                    // //console.log('myresultado', resultado)

                    const atributos = {
                        ...this.datos.atributos,
                        fullNameReceptor: resultado['nombre_completo'] ? resultado['nombre_completo'] : resultado['nombre_o_razon_social']
                    }
                    console.log('---- ', atributos)

                    this.$store.commit('ventas/UPDATE_DATOS', {
                        atributos: atributos
                    })
                    console.log('here---1')
                    this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                } catch (error) {
                    console.log('error ', error)
                    this.$store.commit('mainUI/OPEN_MODAL', { state: false })

                    //console.log('error ', error)
                }
            }
        },
        async ProgramWhatsapp() {
            const { full_name, celularContacto, telefono, phoneClient } = this.datos
            const phone = celularContacto || telefono || phoneClient
            if (!phone) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'No hay número de teléfono registrado',
                    color: 'red'
                })
                await sleep(3000)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                return
            }

            const message = `Hola ${full_name}, su pedido ha sido *PROGRAMADO* para envío. Le mantendremos informado del progreso.`
            const original = String(phone || '')
            const raw = original.replace(/\D+/g, '')
            const normalized = raw.startsWith('51') ? raw : `51${raw}`
            if (!/^51\d{7,12}$/.test(normalized)) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'ERROR - Número inválido para WhatsApp',
                    color: 'red'
                })
                return
            }
            const whatsappUrl = `https://wa.me/${normalized}?text=${encodeURIComponent(message)}`
            window.open(whatsappUrl, '_blank')

            // Marcar como enviado
            await this.$store.dispatch('ventas/patchVenta', { ...this.datos, atributos: { ...this.datos.atributos, mensajeProgramaEnvio: true } })
        },

        async agendarWhatsapp() {
            const { full_name, celularContacto, telefono, phoneClient, direccion, atributos, referencia, productos } = this.datos
            const phone = celularContacto || telefono || phoneClient
            if (!phone) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'No hay número de teléfono registrado',
                    color: 'red'
                })
                await sleep(3000)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                return
            }

            const prodPriceDes = productos.sort((a, b) => b.price - a.price)
            const nombreDep = this.resolvedUbigeo?.departamento || ''
            const nombreProv = this.resolvedUbigeo?.provincia || ''
            const nombreDist = this.resolvedUbigeo?.distrito || ''
            const formaEntrega = this.tipoFormaEntrega.find((x) => x.id == this.datos.formaEntrega)
            const agenciaEnvio = this.listDispatchers.find((x) => x.id == this.datos.agenciaEnvio)

            let nameProductos = '--'
            const principalProducto = `${prodPriceDes[0].name}, ${prodPriceDes[0].unidades} unidad(s)`
            const seconProds = prodPriceDes.slice(1)
            for (const iterator of seconProds) {
                nameProductos =
                    prodPriceDes.length <= 1 ? '--' : nameProductos.concat(`• ${iterator?.name || ''}, ${iterator?.unidades || ''} unidad(s)`)
            }
            const destino = `${direccion} - ${nombreDep} - ${nombreProv} - ${nombreDist} - Referencia - ${referencia}`

            const message = `Hola ${full_name},

Su pedido se enviará el día de mañana mediante AGENCIA
Por favor confírmenos los siguientes datos de envío:

[Producto principal:] ${principalProducto}
${nameProductos !== '--' ? `[Otros productos:]\n${nameProductos}` : ''}

[Destino:] ${destino}
[Receptor:] ${atributos?.fullNameReceptor} (DNI: ${atributos?.documentoReceptor})
[Contacto:] ${celularContacto}
[Forma de entrega:] ${formaEntrega?.text || 'No especificada'}
[Agencia:] ${agenciaEnvio?.name || 'No especificada'}`

            const original2 = String(phone || '')
            const raw2 = original2.replace(/\D+/g, '')
            const normalized2 = raw2.startsWith('51') ? raw2 : `51${raw2}`
            if (!/^51\d{7,12}$/.test(normalized2)) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'ERROR - Número inválido para WhatsApp',
                    color: 'red'
                })
                return
            }
            const whatsappUrl = `https://wa.me/${normalized2}?text=${encodeURIComponent(message)}`
            window.open(whatsappUrl, '_blank')

            // Marcar como enviado
            await this.$store.dispatch('ventas/patchVenta', { ...this.datos, atributos: { ...this.datos.atributos, mensajeAgencia: true } })
        },

        async aplicativoWhatsapp() {
            const { full_name, celularContacto, telefono, phoneClient, montoDelivery, productos } = this.datos
            const phone = celularContacto || telefono || phoneClient
            if (!phone) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'No hay número de teléfono registrado',
                    color: 'red'
                })
                await sleep(3000)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                return
            }

            const namePrinc = productos.length > 0 ? productos.find((x) => x.name) : null
            let listaProductos = ''
            const cant = productos.length - 1
            listaProductos = listaProductos.concat(`• ${namePrinc.name}  ${cant > 0 ? ` y ${cant} producto(s) más` : ''}`)

            const message = `Hola ${full_name},

Su pedido será entregado por aplicativo

${listaProductos}
[Monto delivery:] S/ ${montoDelivery || '---'}

Por favor confirme su ubicación para coordinar la entrega.`

            const original3 = String(phone || '')
            const raw3 = original3.replace(/\D+/g, '')
            const normalized3 = raw3.startsWith('51') ? raw3 : `51${raw3}`
            if (!/^51\d{7,12}$/.test(normalized3)) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'ERROR - Número inválido para WhatsApp',
                    color: 'red'
                })
                return
            }
            const whatsappUrl = `https://wa.me/${normalized3}?text=${encodeURIComponent(message)}`
            window.open(whatsappUrl, '_blank')

            // Marcar como enviado
            await this.$store.dispatch('ventas/patchVenta', { ...this.datos, atributos: { ...this.datos.atributos, mensajeAplicativo: true } })
        },

        async recojoWhatsapp() {
            const { full_name, celularContacto, telefono, phoneClient, productos } = this.datos
            const phone = celularContacto || telefono || phoneClient
            if (!phone) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'No hay número de teléfono registrado',
                    color: 'red'
                })
                await sleep(3000)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                return
            }

            const principal = (productos || []).find((x) => x?.description)
            const adicionales = Math.max((productos || []).length - 1, 0)
            const adicionalText = adicionales > 0 ? `* ${adicionales} producto${adicionales === 1 ? '' : 's'} adicional${adicionales === 1 ? '' : 'es'}` : ''

            const message = `Hola ${full_name},

Le informamos que su pedido ya se encuentra listo para recojo:

* ${principal?.description || 'Producto'}
${adicionalText}

📍 Ubicación:
📦 Taller Lima N°2
Mz "B" Lt 4 y 5, Asoc. de Propietarios Señor de Muruhuay - San Martín de Porres
🔗 https://maps.app.goo.gl/dRYD41HUqhPbKs4V8

Por favor, agende previamente su horario y acérquese dentro de nuestro horario de atención:
🕘 9:00 a.m. a 11:00 a.m.
🕑 2:00 p.m. a 5:00 p.m.

Quedamos atentos a su confirmación.
¡Muchas gracias!`

            const raw = String(phone || '').replace(/\D+/g, '')
            const normalized = raw.startsWith('51') ? raw : `51${raw}`
            if (!/^51\d{7,12}$/.test(normalized)) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'ERROR - Número inválido para WhatsApp',
                    color: 'red'
                })
                return
            }
            const whatsappUrl = `https://wa.me/${normalized}?text=${encodeURIComponent(message)}`
            window.open(whatsappUrl, '_blank')

            // Marcar como enviado
            await this.$store.dispatch('ventas/patchVenta', { ...this.datos, atributos: { ...this.datos.atributos, mensajeRecojo: true } })
        },

        async routeWhatsapp() {
            const { full_name, productos, celularContacto, telefono, phoneClient } = this.datos
            const phone = celularContacto || telefono || phoneClient
            if (!phone) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'No hay número de teléfono registrado',
                    color: 'red'
                })
                await sleep(3000)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                return
            }

            let nameProduct = ''
            let index = 0
            productos.map((x, i) => {
                if (i == 0) {
                    nameProduct = x.name
                }
                index = i
            })
            const listproductos = `${index == 0 ? `${nameProduct}` : `${nameProduct} más ${index} producto(s) más`}`

            const message = `Hola ${full_name}, su pedido ${listproductos} está EN CAMINO

Le notificaremos cuando llegue a su destino.`
            const original = String(phone || '')
            const raw = original.replace(/\D+/g, '')
            const normalized = raw.startsWith('51') ? raw : `51${raw}`
            if (!/^51\d{7,12}$/.test(normalized)) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'ERROR - Número inválido para WhatsApp',
                    color: 'red'
                })
                return
            }
            const whatsappUrl = `https://wa.me/${normalized}?text=${encodeURIComponent(message)}`
            window.open(whatsappUrl, '_blank')

            // Marcar como enviado
            await this.$store.dispatch('ventas/patchVenta', { ...this.datos, atributos: { ...this.datos.atributos, mensajeEnCamino: true } })
        },
        async deliveredWhatsapp() {
            const { full_name, productos, celularContacto, telefono, phoneClient } = this.datos
            const phone = celularContacto || telefono || phoneClient
            if (!phone) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'No hay número de teléfono registrado',
                    color: 'red'
                })
                await sleep(3000)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                return
            }

            let nameProduct = ''
            let index = 0
            productos.map((x, i) => {
                if (i == 0) {
                    nameProduct = x.name
                }
                index = i
            })
            const listproductos = `${index == 0 ? `${nameProduct}` : `${nameProduct} más ${index} producto(s) más`}`

            const message = `Hola ${full_name}, su pedido ${listproductos} ha sido ENTREGADO exitosamente

¡Gracias por su preferencia!`
            const original2 = String(phone || '')
            const raw2 = original2.replace(/\D+/g, '')
            const normalized2 = raw2.startsWith('51') ? raw2 : `51${raw2}`
            if (!/^51\d{7,12}$/.test(normalized2)) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'ERROR - Número inválido para WhatsApp',
                    color: 'red'
                })
                return
            }
            const whatsappUrl = `https://wa.me/${normalized2}?text=${encodeURIComponent(message)}`
            window.open(whatsappUrl, '_blank')

            // Marcar como enviado
            await this.$store.dispatch('ventas/patchVenta', { ...this.datos, atributos: { ...this.datos.atributos, mensajeEntregado: true } })
        },
        async sendSmsWhatsapp() {
            const {
                direccion,
                referencia,
                atributos,
                celularContacto,
                googleMaps,
                telefono,
                phoneClient,
                tipoEntrega,
                productos,
                importeTotal,
                importeAbonado
            } = this.datos

            const phone = celularContacto || telefono || phoneClient
            if (!phone) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'No hay número de teléfono registrado',
                    color: 'red'
                })
                await sleep(3000)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                return
            }

            const dep = this.resolvedUbigeo?.departamento || ''
            const prov = this.resolvedUbigeo?.provincia || ''
            const dist = this.resolvedUbigeo?.distrito || ''
            const findTipoEntrega = this.tipoSelectEntrega.find((x) => x.id == tipoEntrega)
            const estadoDeudaCalc = importeTotal - (importeAbonado || 0)

            let listProducts = ''
            for (const iterator of productos) {
                listProducts += `\n• *${iterator.description}* ; Cantidades ${iterator.unidades}`
            }

            const msgWhatsapp = `¡Hola! 
Este mensaje es para verificar si los datos brindados para el envío de su producto son correctos, así poder gestionar su envío cuando el producto esté listo.

[Forma de Entrega]
Destino: ${direccion || ''} - ${dep || ''} - ${prov || ''} - ${dist || ''} - referencia - ${referencia || ''}

Agencia de envío:
Persona autorizada: ${atributos.fullNameReceptor || ''} ; Dni:${atributos.documentoReceptor || ''} ; cel.${celularContacto || telefono}
Ubicación en Maps: ${googleMaps || ''}

[Datos del Flete]
Tipo de entrega: ${findTipoEntrega?.text}
Monto: ${importeTotal}
Estado de la deuda: ${estadoDeudaCalc == 0 ? 'Cancelado' : `Pendiente - S/ ${estadoDeudaCalc}`}
Bultos a recibir:${listProducts}`

            const original4 = String(phone || '')
            const raw4 = original4.replace(/\D+/g, '')
            const normalized4 = raw4.startsWith('51') ? raw4 : `51${raw4}`
            if (!/^51\d{7,12}$/.test(normalized4)) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'ERROR - Número inválido para WhatsApp',
                    color: 'red'
                })
                return
            }
            const whatsappUrl = `https://wa.me/${normalized4}?text=${encodeURIComponent(msgWhatsapp)}`
            window.open(whatsappUrl, '_blank')

            // Marcar como enviado
            await this.$store.dispatch('ventas/patchVenta', {
                ...this.datos,
                atributos: { ...this.datos.atributos, confirmacionDatoEnvio: true }
            })
        },
        async printEnvio(tipoDoc) {
            try {
                const departamento = this.resolvedUbigeo?.departamento || ''
                const provincia = this.resolvedUbigeo?.provincia || ''
                const distrito = this.resolvedUbigeo?.distrito || ''

                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'generando Reporte'
                })
                const date = format(new Date(), 'dd/MM/yyyy')
                const base64 = await this.$store.dispatch('reporte/reporteDatosEnvio', {
                    ...this.datos,
                    departamento,
                    provincia,
                    distrito,
                    date,
                    tipoDoc
                })

                //this.pathURL = base64
                //console.log('pathURL ', this.pathURL)
            } catch (error) {
                //console.log('err ', error)
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'datos incompletos'
                })
            }
        }
    },
    async mounted() {
        await Promise.all([
            this.$store.dispatch('proveedor/findProveedor'),
            this.$store.dispatch('proveedor/findDriver'),
            this.$store.dispatch('proveedor/findTransport')
        ])
    },
    watch: {
        'datos.atributos.idModotransporte'(val) {
            if (val == 2) {
                // Transporte privado: limpiar agencia
                this.$store.commit('ventas/UPDATE_DATOS', { agenciaEnvio: null })
            } else if (val == 1) {
                // Transporte público: limpiar chofer y placa
                this.$store.commit('ventas/UPDATE_DATOS', {
                    atributos: { ...this.datos.atributos, idChofer: null, placaVehiculo: null }
                })
            }
        },
        ubigeoSearch(val) {
            clearTimeout(this.searchTimeout)
            // Ignorar cuando el valor es el label del item ya seleccionado
            if (this.resolvedUbigeo && val === this.ubigeoLabel(this.resolvedUbigeo)) return
            if (!val || val.length < 2) return
            this.searchTimeout = setTimeout(async () => {
                this.ubigeoLoading = true
                try {
                    this.ubigeoItems = await this.$store.dispatch('sedes/searchDistrito', val)
                } finally {
                    this.ubigeoLoading = false
                }
            }, 300)
        }
    },
    async created() {
        await Promise.all([this.$store.dispatch('users/getPersonas'), this.$store.dispatch('users/getLista')])
        this.datos.atributos.idModotransporte = this.datos.atributos.idModotransporte || 2
        if (!this.datos.atributos.fechaEnvio) {
            this.$store.commit('ventas/UPDATE_DATOS', {
                atributos: {
                    ...this.datos.atributos,
                    fechaEnvio: this.today
                }
            })
        }
        console.log('this.datos', this.datos)

        if (this.datos.ubigeo) {
            const found = await this.$store.dispatch('sedes/getUbigeoById', this.datos.ubigeo)
            if (found && found.length > 0) {
                this.resolvedUbigeo = found[0]
                this.ubigeoItems = [found[0]]
            }
        }
    }
}
</script>
